import { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CheckboxGroup, Checkbox } from '@ds';
import { TrialProgramImage } from '@ui';
import { AuthContext } from '@lp/core/auth';
import { AdminPermissions } from '@/permissions';
import { EmployeeFormValues } from '@/types';
import { OrganType } from '@/api/apis/case';
import { useTrialProgramsList } from '@/hooks/useTrialProgramsList';

type EmployeeTrialProgramsSelectorProps = {
  isReadOnly?: boolean;
};

export const EmployeeTrialProgramsSelector = ({ isReadOnly }: EmployeeTrialProgramsSelectorProps) => {
  const { checkPermission, employeeData } = useContext(AuthContext);
  const hasEmployeeTrialProgramEditPermission = checkPermission(AdminPermissions.TmdxUsersCSUpdateTrialProgram);
  const { control } = useFormContext<EmployeeFormValues>();
  const { trialProgramsList } = useTrialProgramsList();

  const getIsTrialOrganLeadership = (organ: OrganType) => {
    return hasEmployeeTrialProgramEditPermission && !!employeeData?.employee.organType?.includes(organ);
  };

  return (
    <Controller
      name="trialProgramIds"
      control={control}
      render={({ field: { value, ref, onChange, ...field }, fieldState: { invalid, error } }) => (
        <CheckboxGroup
          orientation="horizontal"
          isInvalid={invalid}
          isDisabled={isReadOnly}
          errorMessage={error?.message}
          value={value ?? []}
          onValueChange={onChange}
          {...field}
        >
          {trialProgramsList.map((option) => (
            <Checkbox
              key={option.value}
              isDisabled={!getIsTrialOrganLeadership(option.organ)}
              value={option.value}
              className="ps-0 py-0"
            >
              <TrialProgramImage organ={option.organ} />
            </Checkbox>
          ))}
        </CheckboxGroup>
      )}
    />
  );
};
